export default __webpack_public_path__ + "static/media/pathology.b58f8830.svg";